/** Shared header circular actions (moon / bell / settings). */

/** 44×44 hit area on mobile; icons sized in px (not 1em). */
export const HEADER_ACTION_BTN_CLASS =
  "header-action-btn relative inline-flex h-11 w-11 min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-base text-gray-500 transition hover:border-brand-gold-mid/40 hover:bg-brand-cream hover:text-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold-mid/30 dark:border-brand-dark-border dark:bg-brand-dark-elevated dark:text-gray-400 dark:hover:border-brand-gold-mid/40 dark:hover:bg-[#1f1f1f] dark:hover:text-gray-200 sm:h-9 sm:w-9 sm:min-h-9 sm:min-w-9";

/** Pixel size for react-icons `size` — avoids SVG width/height="1em" shrinking with parent font-size. */
export const HEADER_ACTION_ICON_SIZE = 20;

export const HEADER_ACTION_ICON_CLASS = "header-action-btn__icon shrink-0";
